<template>
  <div class="text-white bg-zt-primary-200 flex w-full document--header items-center px-6"
      :style="{ marginTop: iframeTokenValid && isMobile ? '54px' : '' }"
>
    <button data-vs-button="go-back" class="outline-none text-left w-1/3 text-zt-xl" @click="$router.back()">
      <slot name="left-section" />
      <!-- <zt-icon name="angle-left" /> -->
    </button>
    <p class="w-1/3 text-center font-bold">
      {{ document.nombre ? document.nombre : document.periodo }}
    </p>
    <template v-if="documentSigned && isCompatibleDownload">
      <button data-vs-button="share-document" class="text-zt-xl text-right w-1/3 outline-none" v-if="!isXmlDocument"
        @click="sharePDF">
        <slot name="right-section" />
      </button>
      <div v-else class="w-1/3 relative">
        <div class="w-full flex justify-end">
          <button data-vs-button="show-opts" class="text-zt-xl outline-none"
            @click="showDownloadOpts = !showDownloadOpts">
            <slot name="right-section" />
          </button>
        </div>
        <div v-if="showDownloadOpts"
          class="w-auto py-2 px-2 absolute border-2 right-0 border-zt-primary-200 z-50 bg-white mt-2 flex flex-col">
          <button data-vs-button="share-pdf" @click="sharePDF" class="mb-2 text-zt-primary-200 focus:outline-none">
            {{ $t("message.DocumentsComponents.pdfFile") }}
          </button>
          <button data-vs-button="share-xml" @click="shareXML" class="text-zt-primary-200 focus:outline-none">
            {{ $t("message.DocumentsComponents.xmlFile") }}
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { includes } from 'lodash'
import Users from '@/apiClient/Users'
import { useWindowResize } from '@sichern/ui-elements'

const shareFiles = (file, type) => {
  const element = document.createElement('a')
  element.setAttribute('href', file)
  element.setAttribute('download', `document.${type}`)
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}
export default {
  name: 'DocumentDetailMenu',
  data() {
    return {
      profile: '',
      idApp: '',
      idDoc: '',
      pdfBlob: '',
      xmlBlob: '',
      showDownloadOpts: false,
      statusSigned: [
        'FIRMADO CONFORME',
        'FIRMADO DISCONFORME',
        'NO REQUIERE FIRMA'
      ],
      windowResize: useWindowResize(this)

    }
  },
  created() {
    this.profile = new Users()

    this.idApp = this.user.aplicacion.id
    this.iddoc = this.document.id
  },
  computed: {
    isMobile() {
      return this.windowResize.width < 1024
    },
    ...mapState('documents', ['document']),
    ...mapState(['user']),
    isEform() {
      return (
        this.document.tipo_formato === 'eform' &&
        !includes(this.document.archivo, 'pdf')
      )
    },
    documentSigned() {
      return includes(this.statusSigned, this.document.firmado)
    },
    isXmlDocument() {
      return includes(this.document.tipo_formato, 'xml')
    },
    isCompatibleDownload() {
      const agent = navigator.userAgent
      return !(agent.includes('iPhone') || agent.includes('iPad'))
    },
    iframeTokenValid() {
      return this.$iframeMessages.isTokenValid()
    }
  },
  methods: {
    sharePDF() {
      this.profile
        .showPdfDownload(this.idApp, this.iddoc)
        .then(res => {
          const data_uri_prefix = 'data:application/pdf;base64,'
          this.pdfBlob = data_uri_prefix + res
        })
        .then(() => {
          shareFiles(this.pdfBlob, 'pdf')
        })
    },
    shareXML() {
      this.profile
        .showXmlDownload(this.idApp, this.iddoc)
        .then(res => {
          const data_uri_prefix = 'data:application/xml;base64,'
          this.xmlBlob = data_uri_prefix + res
        })
        .then(() => {
          shareFiles(this.xmlBlob, 'xml')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.document--header {
  height: 64px;
}

.outline-none {
  outline: none;
}
</style>
